import React from 'react';

import { PP_SECONDARY_COLOR } from '@/styles';

const chevronDown =
  'M4.29289 8.29289C4.68342 7.90237 5.31658 7.90237 5.70711 8.29289L12 14.5858L18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289C20.0977 8.68342 20.0977 9.31658 19.7071 9.70711L12.7142 16.7001C12.3197 17.0945 11.6802 17.0945 11.2858 16.7001L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289Z';
const chevronUp =
  'M4.29289 15.7071C4.68342 16.0976 5.31658 16.0976 5.70711 15.7071L12 9.4142L18.2929 15.7071C18.6834 16.0976 19.3166 16.0976 19.7071 15.7071C20.0977 15.3166 20.0977 14.6834 19.7071 14.2929L12.7142 7.29995C12.3197 6.90549 11.6802 6.90555 11.2858 7.29995L4.29289 14.2929C3.90237 14.6834 3.90237 15.3166 4.29289 15.7071Z';

export const ChevronIcon = ({
  isActive,
}: {
  isActive: boolean;
}): React.ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d={isActive ? chevronUp : chevronDown}
      fill={PP_SECONDARY_COLOR}
    />
  </svg>
);
